import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
const { FiExternalLink, FiStar, FiZap, FiDroplet, FiShield } = FiIcons;

const LUMISPA_URL = 'https://nskn.co/4rIDmY';

const benefits = [
  { icon: FiZap,      text: 'Dual-action silicone cleanse + massage in 2 minutes' },
  { icon: FiDroplet,  text: 'Removes 20x more makeup and impurities than hands alone' },
  { icon: FiShield,   text: 'Gentle enough for sensitive skin, no harsh bristles' },
  { icon: FiStar,     text: 'Clinical-grade results without the spa price tag' },
];

export default function ShopView() {
  return (
    <div className="flex-1 overflow-y-auto px-4 pt-6 pb-8"
         style={{ background: 'linear-gradient(135deg, #fbd7cd22 0%, #e5e1f922 50%, #c8e6c922 100%)' }}>

      <div className="mb-6">
        <h1 className="text-2xl font-bold text-slate-800 font-sans">Shop</h1>
        <p className="text-sm text-slate-500 mt-1 font-sans">
          Products we love and use, curated for your glow journey.
        </p>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="glass-card rounded-3xl overflow-hidden mb-4"
      >
        <div
          className="w-full h-40 flex items-center justify-center"
          style={{ background: 'linear-gradient(135deg, #f9a8d4 0%, #c084fc 50%, #818cf8 100%)' }}
        >
          <div className="text-center">
            <div className="text-5xl mb-1">✨</div>
            <span className="text-white text-sm font-semibold font-sans tracking-wide uppercase opacity-90">
              Featured Device
            </span>
          </div>
        </div>

        <div className="p-5">
          <div className="flex items-start justify-between mb-1">
            <div>
              <p className="text-xs font-semibold text-purple-500 uppercase tracking-widest font-sans mb-1">
                Nu Skin
              </p>
              <h2 className="text-xl font-bold text-slate-800 font-sans leading-tight">
                ageLOC LumiSpa iO
              </h2>
            </div>
            <span className="text-xs bg-pink-100 text-pink-600 font-semibold px-2 py-1 rounded-full font-sans whitespace-nowrap">
              Editor Pick
            </span>
          </div>

          <p className="text-sm text-slate-600 font-sans mt-2 mb-4 leading-relaxed">
            The LumiSpa iO is a smart facial cleansing and firming device that pairs
            with an app to personalise your skincare routine. Two minutes, twice a day,
            visibly softer, cleaner, more radiant skin.
          </p>

          <div className="space-y-2 mb-5">
            {benefits.map(({ icon: Icon, text }, i) => (
              <div key={i} className="flex items-start gap-3">
                <div className="w-7 h-7 rounded-full bg-purple-50 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <Icon className="text-purple-500 text-xs" />
                </div>
                <p className="text-sm text-slate-600 font-sans leading-snug">{text}</p>
              </div>
            ))}
          </div>

          <a
            href={LUMISPA_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 w-full py-3.5 rounded-2xl font-semibold text-sm font-sans text-white transition-opacity active:opacity-80"
            style={{ background: 'linear-gradient(135deg, #c084fc, #818cf8)' }}
          >
            Shop LumiSpa iO
            <FiExternalLink className="text-sm" />
          </a>

          <p className="text-center text-xs text-slate-400 font-sans mt-3 leading-snug">
            Affiliate link, we may earn a small commission at no extra cost to you.
          </p>
        </div>
      </motion.div>

      <div className="glass-card rounded-2xl px-5 py-4 text-center">
        <p className="text-sm text-slate-500 font-sans">
          More products coming soon, stay tuned for the full Glowlytix store.
        </p>
      </div>
    </div>
  );
}
